import { AgeConfirmTableProps } from './interface'

export function withAgeConfirmTable(Component: React.FC<AgeConfirmTableProps>) {
  function WithAgeConfirmTable(props: AgeConfirmTableProps) {
    return <Component {...props} />
  }

  return WithAgeConfirmTable
}
